import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import PageThemeReports from '../pages/themeReports/PageThemeReports';

const RouteThemeReports = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageThemeReports />
      </Route>
      {/* <Route path={`${path}/:_id/preview`}>
        <PageCompetitionPreview />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageCompetition />
      </Route> */}
    </Switch>
  );
};

export default RouteThemeReports;
